/**
 * PBIS CSV export endpoints return a signed S3 URL, not raw CSV text.
 * @param {unknown} body
 * @returns {{ url: string, fileName: string, csvContent: string }}
 */
export function parsePbisCsvExportResponse(body) {
  if (typeof body === "string") {
    const csvContent = body.trim()
    return {
      url: "",
      fileName: "",
      csvContent
    }
  }

  const data =
    body?.url || body?.file_name || body?.fileName ? body : (body?.data ?? {})

  return {
    url: String(data?.url ?? "").trim(),
    fileName: String(data?.file_name ?? data?.fileName ?? "").trim(),
    csvContent: ""
  }
}
